import { render, staticRenderFns } from "./Totalizadores.vue?vue&type=template&id=26ed648a&scoped=true&lang=pug"
import script from "./Totalizadores.vue?vue&type=script&lang=js"
export * from "./Totalizadores.vue?vue&type=script&lang=js"
import style0 from "./Totalizadores.vue?vue&type=style&index=0&id=26ed648a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed648a",
  null
  
)

export default component.exports